var React = require('react');

function Wallpaper (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Wallpaper Icon"),React.createElement("path",{"d":"M17.5 2C18.881 2 20 3.119 20 4.5l0 11c0 1.381-1.119 2.5-2.5 2.5l-15 0C1.119 18 0 16.881 0 15.5l0-11C0 3.119 1.119 2 2.5 2l15 0zM19 15.5l0-11c0-.827-.673-1.5-1.5-1.5l-15 0C1.673 3 1 3.673 1 4.5l0 8.363 3.904-3.905c1.279-1.277 3.358-1.277 4.636 0l8.034 8.034c.792-.039 1.426-.69 1.426-1.492zm-18 0c0 .827.673 1.5 1.5 1.5l13.667 0-7.334-7.335c-.888-.889-2.333-.889-3.222 0L1 14.277 1 15.5zM15 5c1.103 0 2 .896 2 2 0 1.104-.897 2-2 2-1.103 0-2-.896-2-2 0-1.104.897-2 2-2zm0 3c.552 0 1-.448 1-1 0-.551-.448-1-1-1-.552 0-1 .449-1 1 0 .552.448 1 1 1z","fill":"currentColor","fillRule":"evenodd","key":1})]);
}

Wallpaper.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Wallpaper;

Wallpaper.default = Wallpaper;
